import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/B6';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 保戶進入受益人匯款帳號約定/變更前，取得先前受益人匯款帳號約定/變更記錄
export function getInfoB6() {
    return get(`${url}/info`);
}

// 取得銀行的總行下拉選單
export function getBankInfoB6() {
    return get(`${url}/bankInfo`);
}

// 取得銀行的分行下拉選單，只有台幣帳戶可以搜尋分行
// "bankNo": "string" 傳入總行代碼
export function getBranchBankInfoB6(bankNo) {
    return post(`${url}/branchBankInfo`, { bankNo: bankNo });
}

// 送出受益人匯款帳號約定/變更
export function submitB6(data) {
    return post(`${url}/submit`, data, {
        ...options,
        errorDialog: false,
        repeatRequestCancel: true,
        closeAlert: true,
    });
}
